import type { Chip } from "../core/chip";
import type { Route } from "../core/route";
import { useModalFocus } from "../accessibility/useModalFocus";

type Props = {
  chip: Chip;
  selected?: Route;
  onPick: (route: Route) => void;
  onContinue: () => void;
  onClose: () => void;
};
export function InvokeSheet({
  chip,
  selected,
  routes,
  onPick,
  onContinue,
  onClose,
}: Props & { routes: Route[] }) {
  const dialogRef = useModalFocus<HTMLDivElement>(".procedure-row");
  return (
    <div
      ref={dialogRef}
      class="overlay-sheet"
      role="dialog"
      aria-modal="true"
      aria-labelledby="invoke-title"
    >
      <span class="sheet-handle" />
      <span class="eyebrow">LEGAL PROCEDURE</span>
      <h2 id="invoke-title">INVOKE</h2>
      <div class="context-meta">
        {chip.id.toUpperCase()} · REV {chip.revision}
      </div>
      <p>GOAL — {chip.goal}</p>
      <div class="procedure-list">
        {routes.map((route) => (
          <button
            class={`procedure-row ${selected?.id === route.id ? "selected" : ""}`}
            aria-pressed={selected?.id === route.id}
            aria-label={`${route.label}${selected?.id === route.id ? " SELECTED" : ""}`}
            onClick={() => onPick(route)}
            key={route.id}
          >
            <strong>{route.label}</strong>
            <span>{route.state}</span>
            <small>
              {route.invoke === "LOREMINE"
                ? "Extract and organize relevant knowledge."
                : route.invoke === "ARTEMIS"
                  ? "Generate or refine visual direction."
                  : route.invoke === "BUILD"
                    ? "Implement the selected change."
                    : "Check integrity and acceptance criteria."}
            </small>
          </button>
        ))}
      </div>
      <div class="sheet-actions">
        <button class="secondary-button" onClick={onClose}>
          CANCEL
        </button>
        <button
          class="primary-button"
          disabled={!selected}
          onClick={onContinue}
        >
          CONTINUE
        </button>
      </div>
    </div>
  );
}
